import { SPLOOT_BADGE_COLOR } from "../themes";
import { ESessionStatus } from "./session.constants";

export const UNATTENDED_SESSION_ACTION_STATUS_BADGE_COLORS = {
  [ESessionStatus.RESCHEDULED]: SPLOOT_BADGE_COLOR.BLUE,
  [ESessionStatus.CANCELLED]: SPLOOT_BADGE_COLOR.RED,
  [ESessionStatus.COMPLETED]: SPLOOT_BADGE_COLOR.GREEN,
} as const;

export const VALID_UNATTENDED_SESSION_ACTION_STATUSES = [
  ESessionStatus.RESCHEDULED,
  ESessionStatus.CANCELLED,
  ESessionStatus.COMPLETED,
] as const;

export const UNATTENDED_SESSION_DRAWER_CONSTANTS = {
  LOADING_MESSAGE: "Loading session details...",
  ERROR_MESSAGE: "Error loading session details. Please try again.",
  BUTTON_LABELS: {
    RESCHEDULE: "Reschedule",
    CANCEL: "Cancel",
    COMPLETE: "Complete",
  },
} as const;